import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { store } from '../../store';
import { openConfirmSnackBar, sendPost } from '../../actions'
import { postRecuperarPassword } from '../../actions/postRecuperarPassword';


const validate = values => {
    const errors = {}
    const requiredFields = [
        'password',
        'usuario'
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required'
        }
    })

    return errors
}



const renderTextField = ({
    label, name, type,
    input,
    meta: { touched, invalid, error },
    ...custom

}) => (
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
            variant="outlined"
            margin="normal"

            fullWidth
            type={type}
            //id={name}

            autoComplete={name}
        />
    )

//const FrmLogin = ({ classes, handleSubmit, submitting, onBack, pristine, submitSucceeded }) => {
const FrmLogin = props => {
    const { handleSubmit, pristine, reset, submitting, classes } = props;
    const [open, setOpen] = React.useState(false);

    const [terceroMail, setTerceroMail] = React.useState('');

    function handleClickOpen() {
        setTerceroMail('');
        setOpen(true);
    }

    function hcDiaglogRecuperarClave(e) {
        //console.log("vuamos tercero..." + terceroMail);
        //debugger;
        if (e.target.innerHTML === 'Confirmar') {

            /*if (terceroPasswordNuevo !== terceroPasswordNuevoC) {
                store.dispatch(openConfirmSnackBar('Error: Las contraseña no coinciden.,updatePasswordError'));
                return;
            }*/

            if (terceroMail.length < 6) {
                store.dispatch(openConfirmSnackBar('Error: Ingrese E-Mail ...'));
                return;
            }

            if (terceroMail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(terceroMail)) {
                store.dispatch(openConfirmSnackBar('Error: E-Mail no valido...'));
                return;
            }


            store.dispatch(sendPost());

            var post = {
                terceroMail: terceroMail
            }

            var formBody = [];

            for (var property in post) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(post[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }

            formBody = formBody.join("&");

            const info = props.postRecuperarPassword(formBody);
            //const info = props.postTerceroPassUdp(formBody);
            return info;

        }

        setOpen(false);
    }

    function terceroMailChange(e) {
        setTerceroMail(e.target.value);
    }

    return (
        <div id="key111" className={classes.form}>
            <form className={classes.form} onSubmit={handleSubmit}>
                <div>
                    <Field name="usuario" component={renderTextField} label="Usuario" type="text" autoFocus />
                </div>
                <div>
                    <Field name="password" component={renderTextField} label="Contraseña" type="password" />
                </div>

                <Button type="submit"
                    fullWidth
                    variant="contained"
                    color="secondary"
                    disabled={pristine || submitting}
                    className={classes.submit}>Enviar</Button>

            </form>

            <Grid container>

            </Grid>
            <Dialog open={open} onClose={hcDiaglogRecuperarClave} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Cambiar la contraseña.</DialogTitle>
                <DialogContent>
                    <DialogContentText>Ingresa el correo electrónico de registro para generar una nueva contraseña.</DialogContentText>
                    <TextField onChange={terceroMailChange}
                        autoFocus
                        margin="dense"
                        id="terceroMail"
                        label="Correo Eletrónico"
                        type="email"
                        fullWidth
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={hcDiaglogRecuperarClave} color="primary">Cancelar</Button>
                    <Button onClick={hcDiaglogRecuperarClave} color="primary">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

FrmLogin.propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    //age: PropTypes.number,
    //onBack: PropTypes.func.isRequired,
};


/*
export default reduxForm({
    form: 'FrmLogin', validate
})(FrmLogin);
*/

const mapStateToProps = state => ({
    loggedIn: state.auth.loggedIn,
});

export default connect(mapStateToProps, { postRecuperarPassword })(reduxForm({
    form: 'FrmLogin', validate, enableReinitialize: true
})(FrmLogin));


/*
export default function FrmLogin(classes) {
    //const classes = useStyles();
    //debugger;

    //store.dispatch(setValor(event.target.innerText));

    const pasoAlgo = (event) => {
        store.dispatch(setValor("nueva info..."));
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paperLogin}>

                <Typography component="h1" variant="h5">
                    Inicio de sesión
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        type="email"
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        autoFocus

                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Enviar
          </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2">
                                Olvidó su contraseña?
              </Link>
                        </Grid>
                        <Grid item>
                            <Link href="#" variant="body2">
                                {"¿Aún no tienes cuenta? Regístrate"}
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>

            </Box>
        </Container>
    );
}

//  <MadeWithLove />
*/
